
  export default {
    name: "PdfToImage",
    props: {
      file: { type: File, required: true }
    },
    data() {
      return {
        isConverting: false,
        pdfPages: [],
        selectedPageIndex: 0,
        showPageSelector: false,
        error: null
      }
    },
    watch: {
      file: {
        immediate: true,
        handler(newFile) {
          if (newFile) {
            this.convertPdf(newFile)
          }
        }
      }
    },
    methods: {
      async convertPdf(file) {
        this.error = null
        this.isConverting = true
        try {
          const base64 = await this.readFileAsBase64(file)
          const response = await this.$store.dispatch("idValidator/convertImg2PDF", base64)
          if (response.images && response.images.length > 0) {
            this.pdfPages = response.images
            if (response.page_count > 1) {
              this.showPageSelector = true
            } else {
              this.emitConverted(response.images[0].image, file.name.replace(/\.pdf$/i, ".jpg"))
            }
          } else {
            throw new Error("No images returned from PDF conversion")
          }
        } catch (e) {
          console.error("PDF conversion error:", e)
          this.error = this.$t("components.id_validator.image_cropper.general_error")
          this.$emit("error", e)
        } finally {
          this.isConverting = false
        }
      },
      readFileAsBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = (e) => resolve(e.currentTarget.result)
          reader.onerror = () => reject(new Error("Failed to read PDF file"))
          reader.readAsDataURL(file)
        })
      },
      confirmPageSelection() {
        const selected = this.pdfPages[this.selectedPageIndex]
        this.showPageSelector = false
        this.emitConverted(selected.image, this.file.name.replace(/\.pdf$/i, ".jpg"))
      },
      cancelPageSelection() {
        this.showPageSelector = false
        this.$emit("cancel")
      },
      emitConverted(imageBase64, fileName) {
        this.$emit("converted", { image: imageBase64, fileName })
      }
    }
  }
